import { useEffect, useState } from "react";
import "./ResponseDetailsGeneric.css";
import { FormResponseExtended, Question } from "effno-core";
import { Response } from "effno-core";

type ResponseDetailsGenericProps = {
    question: Question | null;
    responses: FormResponseExtended[] | null;
    valueName: string;
}

export const ResponseDetailsGeneric = ({question, responses, valueName} : ResponseDetailsGenericProps) => {

    const exampleResponses : string[] = [];
    let emptyResponses  = 0;
    let responsesCount = 0;
   
    if (responses) {
        responses.forEach((formResponse: FormResponseExtended)  => {
            formResponse.responses.forEach((response: Response) => {
                if (response.questionId === question?.id) {
                    responsesCount++;
                    const responseValues = JSON.parse(response.responseValues);

                    console.log("[ResponseDetailsGeneric] responseValue: ", responseValues[valueName]);

                    if (!responseValues[valueName]) {
                        emptyResponses++;
                    } else {
                        if (exampleResponses.length < 10) {
                            exampleResponses.push(responseValues[valueName]);
                        }
                    }
                    
                }

            })
        });
    }

    return (
        <div className="response-details-generic">

            <div className="response-details-generic-header">
                <div className="response-details-generic-stat">
                    Responses: {responsesCount}
                </div>
                <div className="response-details-generic-stat">
                    Empty Responses: {emptyResponses} ({
                        responses?.length ? 
                            Math.floor(emptyResponses / responsesCount * 100) : 
                            0
                        }%)
                </div>
                <p/>
                
            </div>

            <div className="response-details-generic-examples-header">
                Examples:
            </div>
            <div className="response-details-generic-examples">
                {exampleResponses.map((example: string, index) => {
                    return (
                        <div className="response-details-generic-example">
                            {example}
                        </div>
                    )
                })}
                {exampleResponses.length === 0 && 
                    <div className="response-details-generic-example">
                        No responses yet
                    </div>
                }
            </div>       

        </div>
    )
}